module.exports = __webpack_public_path__ + "img/vertical_4_3_2.6c061551.png";